export default __webpack_public_path__ + "static/media/v_wdt_c_1.3de13418.mp3";